import { useState } from 'react';
import {
  FaTrash,
  FaPlus,
  FaChevronDown,
  FaChevronUp,
  FaFileAlt,
} from 'react-icons/fa';

export default function LicenseSection({ licenses, setLicenses }) {
  const [expandedId, setExpandedId] = useState(licenses.length ? licenses[0].id : null);

  const handleChange = (index, field, value) => {
    const updated = [...licenses];
    updated[index][field] = value;
    setLicenses(updated);
  };

  const handleFileChange = (index, file) => {
    const updated = [...licenses];
    updated[index].file = file;
    setLicenses(updated);
  };

  const addNewEntry = () => {
    const newEntry = {
      id: Date.now(),
      title: '',
      number: '',
      file: null,
    };
    setLicenses([...licenses, newEntry]);
    setExpandedId(newEntry.id);
  };

  const removeEntry = (index) => {
    const updated = [...licenses];
    const removed = updated.splice(index, 1);
    setLicenses(updated);

    if (expandedId === removed[0].id && updated.length > 0) {
      setExpandedId(updated[0].id);
    }
  };

  const toggleExpand = (id) => {
    setExpandedId(id === expandedId ? null : id);
  };

  return (
    <div className="space-y-6">
      {licenses.map((item, index) => {
        const isExpanded = item.id === expandedId;
        return (
          <div
            key={item.id}
            className="border rounded-xl shadow-sm bg-gray-50 relative"
          >
            <div
              className={`flex justify-between items-center p-4 cursor-pointer ${
                isExpanded ? 'border-b' : ''
              }`}
              onClick={() => toggleExpand(item.id)}
            >
              <div className="font-medium text-gray-800">
                {item.title || `License ${index + 1}`}
              </div>
              <div className="flex items-center gap-3">
                <button
                  type="button"
                  onClick={(e) => {
                    e.stopPropagation();
                    removeEntry(index);
                  }}
                  className="text-red-500 hover:text-red-700"
                >
                  <FaTrash />
                </button>
                <span className="text-gray-400">
                  {isExpanded ? <FaChevronUp /> : <FaChevronDown />}
                </span>
              </div>
            </div>

            {isExpanded && (
              <div className="p-4 grid grid-cols-1 md:grid-cols-2 gap-4">
                <input
                  type="text"
                  placeholder="License Title"
                  className="rounded-full border px-4 py-2 w-full"
                  value={item.title}
                  onChange={(e) => handleChange(index, 'title', e.target.value)}
                />

                <input
                  type="text"
                  placeholder="License Number (Optional)"
                  className="rounded-full border px-4 py-2 w-full"
                  value={item.number}
                  onChange={(e) => handleChange(index, 'number', e.target.value)}
                />

                <div className="col-span-2">
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    Upload License File <span className="text-gray-400 text-xs">(PDF, JPG, PNG, DOC - max 30MB)</span>
                  </label>

                  <div
                    className="border-2 border-dashed border-gray-300 p-6 rounded-xl text-center cursor-pointer hover:border-primary hover:bg-blue-50 transition"
                    onClick={() => document.getElementById(`license-file-${item.id}`).click()}
                    onDragOver={(e) => e.preventDefault()}
                    onDrop={(e) => {
                      e.preventDefault();
                      const file = e.dataTransfer.files[0];
                      if (file && file.size <= 30 * 1024 * 1024) {
                        handleFileChange(index, file);
                      } else {
                        alert('File too large or invalid format.');
                      }
                    }}
                  >
                    {item.file ? (
                      <div className="flex items-center justify-center space-x-2">
                        <FaFileAlt className="text-primary" />
                        <span className="text-sm text-gray-700">{item.file.name}</span>
                        <button
                          type="button"
                          className="text-red-500 hover:text-red-700 ml-2"
                          onClick={(e) => {
                            e.stopPropagation();
                            handleFileChange(index, null);
                          }}
                        >
                          <FaTrash />
                        </button>
                      </div>
                    ) : (
                      <div className="text-gray-400 text-sm">
                        Drag & drop or <span className="underline text-primary">browse</span> to upload
                      </div>
                    )}

                    <input
                      id={`license-file-${item.id}`}
                      type="file"
                      accept=".pdf,.doc,.docx,.jpg,.jpeg,.png"
                      className="hidden"
                      onChange={(e) => {
                        const file = e.target.files[0];
                        if (file && file.size <= 30 * 1024 * 1024) {
                          handleFileChange(index, file);
                        } else {
                          alert('File too large or invalid format.');
                        }
                      }}
                    />
                  </div>
                </div>
              </div>
            )}
          </div>
        );
      })}

      <button
        type="button"
        className="mt-4 flex items-center gap-2 text-primary font-semibold"
        onClick={addNewEntry}
      >
        <FaPlus /> Add License
      </button>
    </div>
  );
}
